// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"290":"30971a84","488":"88b1b0f4"}[chunkId] + ".chunk.js";
};